import React from 'react';
import PropTypes from 'prop-types';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';
import { PROPERTY_CONDITION_REPORT_JOB_LINK } from 'common/jobConstants';
import sendDataToMobileApp, {
  SR_MOBILE_APP_ACTION_TYPE_OPEN_URL,
} from 'client/helpers/sendDataToMobileApp';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_WHITE_BLUE_BORDER,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrSunSetupDriverJobPage.less';

const SrSunSetupDriverJobConditionReportLink = ({ userAgent }) => {
  return (
    <div styleName="card" className="fieldsContainer" id="field-listingPhotoUrls">
      <span styleName="cardTitle">Link</span>
      <br />
      <SrText font="greycliff" weight="600" lineHeight="25px">
        {PROPERTY_CONDITION_REPORT_JOB_LINK}
      </SrText>
      <br />
      <SrBox margin="16px 0 0">
        <SrButton
          theme={SR_BUTTON_THEME_ADOBE_WHITE_BLUE_BORDER}
          hasBoxShadow
          type="button"
          onClick={() => {
            const isMobileApp = isUserAgentMobileApp(userAgent);

            if (isMobileApp) {
              sendDataToMobileApp({
                actionType: SR_MOBILE_APP_ACTION_TYPE_OPEN_URL,
                url: PROPERTY_CONDITION_REPORT_JOB_LINK,
              });
            } else {
              global.open(PROPERTY_CONDITION_REPORT_JOB_LINK, '_blank');
            }
          }}
        >
          Complete Form
        </SrButton>
      </SrBox>
    </div>
  );
};

SrSunSetupDriverJobConditionReportLink.propTypes = {
  userAgent: PropTypes.object.isRequired,
};

SrSunSetupDriverJobConditionReportLink.displayName = 'SrSunSetupDriverJobConditionReportLink';

export default SrSunSetupDriverJobConditionReportLink;
